<template>
  <Layout>
    <div class="px-2">
      <div class="lg:flex pt-6 pb-8">
        <div class="w-full lg:w-1/3">
          <h2 class="pb-4">Activity</h2>
        </div>
        <div class="w-full lg:w-2/3 lg:flex lg:justify-end">
          <div class="w-full lg:w-1/4 lg:mr-4 pb-4">
            <pt-form-input
              id="search-input"
              v-model="searchText"
              type="text"
              icon-class="fa-search"
              icon-position="left"
              placeholder="Enter Order ID..."
              @keyup.enter.native="searchActivity"
            />
          </div>
          <div class="w-full lg:w-1/4 pb-2">
            <pt-datepicker
              v-model="dateRange"
              :range="true"
              label=""
            />
          </div>
        </div>
      </div>
      <div class="flex">
        <pt-view-table
          :data="activities"
          :columns="columns"
          :loading="tableLoader"
          :row-class="classes.row"
          :header-class="classes.header"
          :column-class="classes.column"
          :tbody-class="classes.tbody"
          :thead-class="classes.thead"
          :client-side-sort="true"
          class="promo-table shadow border-t z-10"
        />
      </div>
      <div class="flex">
        <pt-pagination
          :total-rows="activityCount"
          :current-page="currentPage"
          :page-size="pageSize"
          :page-sizes="[10, 15, 20]"
          class="mt-8 mb-16"
          @page-changed="pageLimitHandler"
        />
      </div>
      <!-- <div>
        <pre>
          {{ histories }}
        </pre>
      </div> -->
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main';
import { PtViewTable } from '@pathao/ui-components/esm/Table';
import { PtPagination } from '@pathao/ui-components/esm/Pagination';
import { PtButton } from '@pathao/ui-components/esm/Button';
import { PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import { PtDatepicker } from '@pathao/ui-components/esm/Datepicker';
import { ACTIVITY_LIST } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
import { format, parse } from 'date-fns';

const columns = [
  {
    header: 'ID',
    accessor: 'id',
    sortable: {
      type: 'number',
      sortKey: 'id',
    },
  },
  {
    header: 'Created By',
    sortable: {
      type: 'string',
      sortKey: 'user.name',
    },
    component: {
      props: ['rowData'],
      render() {
        return (
          <div>
            <p>{ this.rowData.user.name }</p>
          </div>
        );
      },
    },
  },
  {
    header: 'Type',
    accessor: 'type',
    sortable: {
      type: 'string',
      sortKey: 'type',
    },
  },
  // {
  //   header: 'Data',
  //   accessor: 'data',
  // },
  {
    header: 'Data',
    sortable: {
      type: 'string',
      sortKey: 'data',
    },
    component: {
      props: ['rowData'],
      render() {
        return (
          <div class='ml-12 md:ml-0'>
            <p style='line-height:1.5'>{ this.rowData.data }</p>
          </div>
        );
      },
    },
  },
  {
    header: 'Created At',
    sortable: {
      type: 'number',
      sortKey: 'created_at',
    },
    component: {
      props: ['rowData'],
      render() {
        return (
          <div>
            <span>{ format(parse(this.rowData.created_at), 'MMM DD, YYYY hh:MM a') }</span>
          </div>
        );
      },
    },
  },
];

export default {
  name: 'Activity',
  page: {
    title: 'Activity',
  },
  components: {
    Layout,
    PtViewTable,
    PtPagination,
    PtButton,
    PtDatepicker,
    PtFormInput,
  },
  data() {
    const date = new Date();
    date.setDate(date.getDate() - 15);
    return {
      dateRange: {
        from: date,
        to: new Date(),
      },
      searchText: '',
      activities: [],
      columns,
      tableLoader: false,
      isSearchOnce: false,
      isSearching: false,
      activityCount: 5,
      currentPage: 1,
      pageSize: 20,
      classes: {
        thead: 'bg-grey-lighter w-auto md:w-full',
        tbody: 'bg-white text-center',
        row: 'border-b-4 lg:border-b border-solid border-grey-light mb-0 w-full',
        column: 'p-4 border-b lg:border-b-0', // border-r border-solid
        header: 'py-4',
      },
    };
  },
  watch: {
    searchText: function(newVal) {
      // console.log(this.isSearchOnce);
      if (!newVal && this.isSearchOnce) {
        this.getActivity();
        this.isSearchOnce = false;
      }
    },
    dateRange: function(newVal) {
      if (newVal.from && newVal.to) {
        this.getActivity();
      }
    },
  },
  created() {
    this.getActivity();

    this.$sendEvent('RS_logs');
  },
  methods: {
    searchActivity() {
      this.isSearching = true;
      this.getActivity();
    },
    getActivity(page = '', pageSize = '') {
      // let pageNum = page || 0;
      let perPage = pageSize || 20;
      let searchParam = this.searchText;
      let startDate = format(this.dateRange.from, 'YYYY-MM-DD');
      let endDate = format(this.dateRange.to, 'YYYY-MM-DD');
      let payload = {
        url: ACTIVITY_LIST + 'page=' + page + '&per_page=' + perPage + '&search=' + searchParam + '&start_date=' + startDate + '&end_date=' + endDate,
        method: 'GET',
      };
      this.tableLoader = true;
      apiRequest(payload)
        .then((response) => {
          this.tableLoader = false;
          if (this.isSearching) {
            this.isSearchOnce = true;
            this.isSearching = false;
          }
          this.activities = response.data.logs;
          this.activityCount = response.data.records;
        });
    },
    pageLimitHandler(page, pageSize) {
      this.getActivity(page - 1, pageSize);
    },
  },
};

</script>

<style>
  .vdp-datepicker__calendar {
    /*position: absolute;*/
    right: 0;
  }
</style>
